module.exports = __webpack_public_path__ + "static/media/valentina_guerrero_marin_3.44056120.jpg";